// Browser-Kompatibilität sicherstellen
if (typeof (globalThis as any).global === 'undefined') {
  ;(globalThis as any).global = globalThis
}

// Produktions-Entry-Point für OnlineSurvey Web-Komponente
import { defineCustomElement } from 'vue'
import OnlineSurvey from './OnlineSurvey.ce.vue'

/**
 * OnlineSurvey Web-Komponente registrieren
 */
function initOnlineSurvey(): void {
  try {
    console.log('Registriere OnlineSurvey Web-Komponente...')

    // OnlineSurvey als Custom Element definieren
    const OnlineSurveyElement = defineCustomElement(OnlineSurvey)
    customElements.define('online-survey', OnlineSurveyElement)

    console.log('OnlineSurvey Web-Komponente erfolgreich registriert')
  } catch (error) {
    console.error('Fehler beim Registrieren der OnlineSurvey Web-Komponente:', error)
  }
}

// OnlineSurvey Web-Komponente initialisieren
initOnlineSurvey()
